import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import PrivateRoutes from "./PrivateRoutes";
import { getAccessToken } from "../Util/authHeader";
// import MainAudioPlayer from "../Components/MainAudioPlayer";
// import MultiAudioPlayer from "../Components/MultiAudioPlayer";
// import MultiAudioPlayerrr from "../Components/MultiAudioPlayerrr";
// import IphoneMultiAudioPlayerrr from "../Components/IphoneMultiAudioPlayerrr";
import React, { useEffect, useState } from "react";

import Main from "../Screens/Main/";

import Login from "../Screens/Auth/Login";
import Signup from "../Screens/Auth/Signup";
import ForgotPassword from "../Screens/Auth/ForgotPassword";
import Verification from "../Screens/Auth/Verification";
import ResetPassword from "../Screens/Auth/ResetPassword";


import Home from "../Screens/Home";
import Stories from "../Screens/Stories";
import Relaxation from "../Screens/Relaxation";
import Articles from "../Screens/Articles";
import Sounds from "../Screens/Sounds";
// import Sounds from "../Screens/Sounds2";
import Settings from "../Screens/Settings";
import Upgrade from "../Screens/Upgrade";
import { isIOS, isMobileSafari, isSafari } from "react-device-detect";
import TestMultiAudioPlayer from "../Components/TestMultiAudioPlayer";
import SaveShareMixExternal from "../Screens/SaveShareMixExternal";
import Specials from "../Screens/Specials";
import { PaymentForm } from "../Screens/Upgrade/PaymentForm";
import AudioDetail from "../Screens/AudioDetail";
import HouseholdMember from "../Screens/Settings/HouseHoldMembers";
import CouponSubscription from "../Screens/CouponSubscription";
import ExternalRoutes from "./ExternalRoutes";
import PrivacyPolicy from "../Screens/PrivaryPolicy";
import Account from "../Screens/Account";
import UpgradeSubscription from "../Screens/UpgradeSubscription";
import { UpgradePayment } from "../Screens/UpgradeSubscription/UpgradePayment";
import TermsConditions from "../Screens/TermsConditions";
import MoreOptions from "../Screens/MoreOptions";
import PageNotFound from "../Screens/PageNotFound";
import EditProfile from "../Screens/EditProfile";
import VideoPlayer from "../Screens/VideoPlayer";
import FreeTrial from "../Screens/FreeTrial";
import Redirection from "../Screens/Redirection";
import DownloadApp from "../Screens/DownloadApp";
import RedirectToPromo from "../Screens/RedirectToPromo";
import Propagation from "../Screens/Propagation";
import ShareAudioDetail from "../Screens/ShareAudioDetail";
import DownloadAssets from "../Screens/DownloadAssets";
import FeaturedMixes from "../Screens/FeaturedMixes";
import FeaturedMixesDetail from "../Screens/FeaturedMixes/single";
import PaymentScreen from "../Screens/PaymentScreen";
import Common from "../Util/common";
import MobileWebViewVideo from "../Screens/MobileWebViewVideo";
import MobileWebViewInfoBox from "../Screens/MobileWebViewInfoBox";
import PlaylistScreen from "../Screens/PlaylistScreen";
import BottomPlayerBar from "../Components/BottomPlayerBar/BottomPlayerBar";
import MyMixes from "../Screens/MyMixes";

const WebRoutes = () => {
  const token = getAccessToken();
  return (
    <>
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Main />} />
          {/* <Route
          path="/home"
          element={<Navigate to={token ? "/home" : "/login"} />}
        /> */}
          <Route
            path="/login"
            element={
              <ProtectedRoutes>
                <Login />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/signup"
            element={
              <ProtectedRoutes>
                <Signup />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/download-app"
            element={
              <ProtectedRoutes>
                <DownloadApp />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <ProtectedRoutes>
                <ForgotPassword />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/verification"
            element={
              <ProtectedRoutes>
                <Verification />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/reset-password"
            element={
              <ProtectedRoutes>
                <ResetPassword />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/audio-detail/:type/:id"
            element={
              <PrivateRoutes>
                <AudioDetail />
              </PrivateRoutes>
            }
          />
          <Route
            path="/share/audio-detail/:type/:id"
            element={
              <ShareAudioDetail />
            }
          />
          <Route
            path="/home"
            element={
              <PrivateRoutes>
                <Home />
              </PrivateRoutes>
            }
          />
          <Route
            path="/home/:id"
            element={
              <PrivateRoutes>
                <Home />
              </PrivateRoutes>
            }
          />
          <Route
            path="/home/:sec/:id"
            element={
              <PrivateRoutes>
                <Home />
              </PrivateRoutes>
            }
          />
          <Route
            path="/stories"
            element={
              <PrivateRoutes>
                <Stories />
              </PrivateRoutes>
            }
          />
          <Route
            path="/relax-rest"
            element={
              <PrivateRoutes>
                <Relaxation />
              </PrivateRoutes>
            }
          />
          <Route
            path="/articles"
            element={
              <PrivateRoutes>
                <Articles />
              </PrivateRoutes>
            }
          />
          <Route
            path="/sounds"
            element={
              <PrivateRoutes>
                <Sounds />
              </PrivateRoutes>
            }
          />
          <Route
            path="/featured-mixes"
            element={
              <PrivateRoutes>
                <FeaturedMixes />
              </PrivateRoutes>
            }
          />
          <Route
            path="/featured-mixes/:id"
            element={
              <PrivateRoutes>
                <FeaturedMixesDetail />
              </PrivateRoutes>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoutes>
                <Settings />
              </PrivateRoutes>
            }
          />
          <Route
            path="/edit-profile"
            element={
              <PrivateRoutes>
                <EditProfile />
              </PrivateRoutes>
            }
          />
          <Route
            path="/household-member"
            element={
              <PrivateRoutes>
                <HouseholdMember />
              </PrivateRoutes>
            }
          />
          <Route
            path="/share-earn"
            element={
              <PrivateRoutes>
                <Propagation />
              </PrivateRoutes>
            }
          />
          <Route
            path="/download-assets"
            element={
              <PrivateRoutes>
                <DownloadAssets />
              </PrivateRoutes>
            }
          />
          <Route
            path="/my-mixes"
            element={
              <PrivateRoutes>
                <MyMixes />
              </PrivateRoutes>
            }
          />
          <Route
            path="/share.mix/:id"
            element={
              <SaveShareMixExternal />
            }
          />
          <Route
            path="/share.mix/:sec/:id"
            element={
              <SaveShareMixExternal />
            }
          />
          <Route
            path="/share.playlist/:id"
            element={
              <SaveShareMixExternal />
            }
          />
          <Route
            path="/share.playlist/:sec/:id"
            element={
              <SaveShareMixExternal />
            }
          />
          <Route
            path="/share.playlist.default/:id"
            element={
              <SaveShareMixExternal />
            }
          />
          <Route
            path="/share.playlist.default/:sec/:id"
            element={
              <SaveShareMixExternal />
            }
          />
          <Route
            path="/specials"
            element={
              <PrivateRoutes>
                <Specials />
              </PrivateRoutes>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <PrivateRoutes>
                <PrivacyPolicy />
              </PrivateRoutes>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <PrivateRoutes>
                <TermsConditions />
              </PrivateRoutes>
            }
          />
          <Route
            path="/upgrade-subscription"
            element={
              <PrivateRoutes>
                <UpgradeSubscription />
              </PrivateRoutes>
            }
          />
          <Route
            path="/upgrade-subscription/:id"
            element={
              <PrivateRoutes>
                <UpgradePayment />
              </PrivateRoutes>
            }
          />
          <Route
            path="/account"
            element={
              <PrivateRoutes>
                <Account />
              </PrivateRoutes>
            }
          />
          <Route
            path="/payment"
            element={
              <PrivateRoutes>
                <PaymentScreen />
              </PrivateRoutes>
            }
          />


          <Route
            path="/more-options"
            element={
              <PrivateRoutes>
                <MoreOptions />
              </PrivateRoutes>
            }
          />
          <Route
            path="/subscription"
            element={
              <ProtectedRoutes>
                <Upgrade />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/package-details/:id"
            element={
              <ProtectedRoutes>
                <PaymentForm />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/subscription-specials"
            element={
              <Navigate to="/promo" />
            }
          />

          <Route
            path="/subscription-specials/:couponId"
            element={
              <RedirectToPromo />
            }
          />
          {
            [...Common.LANDING_PAGES, Common.DEAL_PAGES].map((page, index) => (
              <React.Fragment key={index}>
                <Route
                  path={`/${page}`}
                  element={
                    <ExternalRoutes>
                      <CouponSubscription />
                    </ExternalRoutes>
                  }
                />
                <Route
                  path={`/${page}/:couponId`}
                  element={
                    <ExternalRoutes>
                      <CouponSubscription />
                    </ExternalRoutes>
                  }
                />
              </React.Fragment>
            ))
          }

          <Route
            path="/relax.video.player"
            element={
              <ExternalRoutes>
                <VideoPlayer />
              </ExternalRoutes>
            }
          />
          <Route
            path="/freetrial"
            element={
              <ExternalRoutes>
                <FreeTrial />
              </ExternalRoutes>
            }
          />
          <Route
            path="/qr-code"
            element={
              <Redirection />
            }
          />

          <Route
            path="/playlists"
            element={
              <PrivateRoutes>
                <PlaylistScreen />
              </PrivateRoutes>
            }
          />


          {/* Video Route For Relax Mobile Application */}
          <Route
            path="/mobile-video"
            element={
              <MobileWebViewVideo />
            }
          />

          <Route
            path="/install-mobile-app"
            element={
              <Redirection />
            }
          />
          {/* <Route path="*" element={<Main />} /> */}

          <Route
            path="/mobile-webview-infobox"
            element={
              <MobileWebViewInfoBox />
            }
          />

          <Route path="/404" element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/404" />} />


        </Routes>

      </BrowserRouter>


    </>
  );
};

const MainAudioPlayerWrapper = () => {

  {

  }
  const token = getAccessToken();
  const location = useLocation();
  const [tokenStatus, setTokenStatus] = useState(false);
  const [iphoneBrowser, setIphoneBrowser] = useState(false);

  useEffect(() => {
    const newToken = getAccessToken();
    const isMainRoute = location.pathname === "/";
    const paymentScreen = location.pathname === '/payment'
    if (newToken && location.pathname != "/" && !paymentScreen) {
      setTokenStatus(true);
    } else {
      setTokenStatus(false);
    }
  }, [location, token]);

  useEffect(() => {
    if (isMobileSafari || isSafari || isIOS) {
      setIphoneBrowser(true)
    }
  }, [location, token]);

  useEffect(() => {
    if (location.pathname.includes("/share.mix/" ) || location.pathname.includes("/share.playlist/")) {
      document.body.classList.add('share-mixer-external-layout');
    }
  }, [location, token]);



return null;
  // return tokenStatus && iphoneBrowser ? <IphoneMultiAudioPlayerrr /> : tokenStatus ? <MultiAudioPlayerrr /> : null;
};

export default WebRoutes;
